import { Button, Col, Row, Space, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LabelText from "../../../../components/input/LabelText";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";
import { useParams } from "react-router";

export const Requiere2doArrastre = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [newIdSigsa2doArrastre, setNewIdSigsa2doArrastre] = useState();

  const { requiere2doArrastre, idSigsa2doArrastre } = useSelector(
    (state) => state.concesionariosReducer.concesionariosServicio
  );
  //
  useEffect(() => {
    setNewIdSigsa2doArrastre(idSigsa2doArrastre);
  }, [idSigsa2doArrastre]);

  const hanldeChange = (val) =>
    dispatch(startUpdateServicio({ requiere2doArrastre: val }, id));

  const handleClick = (val) =>
    dispatch(
      startUpdateServicio({ idSigsa2doArrastre: newIdSigsa2doArrastre }, id)
    );

  ///

  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Col>
          <Space direction="vertical">
            <Switch
              checked={requiere2doArrastre}
              onChange={hanldeChange}
              checkedChildren="Si"
              unCheckedChildren="No"
            />
          </Space>
        </Col>
        <Col>
          <div className="label">Arrastre Escotel</div>
        </Col>
      </Row>
      {requiere2doArrastre === true && (
        <Row gutter={10}>
          <Col span={20}>
            <LabelText
              value={newIdSigsa2doArrastre}
              onChange={({ target }) => setNewIdSigsa2doArrastre(target.value)}
              size="small"
              label="ID SIGSA - Arrastre"
            />
          </Col>
          <Col span={4} style={{ paddingTop: 17 }}>
            <Button onClick={handleClick} size="small" danger>
              Ok
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};
